import * as React from "react";

import primaryColour from "../../constants";

function SvgVdc(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.06585 18.1841C2.78847 14.9068 2.78847 9.59307 6.06585 6.3157L4.93447 5.18433C1.03226 9.08654 1.03226 15.4133 4.93447 19.3155L6.06585 18.1841Z"
        fill={fill}
      />
      <path
        d="M17.9342 18.1841C21.2116 14.9068 21.2116 9.59307 17.9342 6.3157L19.0656 5.18433C22.9678 9.08654 22.9678 15.4133 19.0656 19.3155L17.9342 18.1841Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5728 8.20875H12.5418C13.4255 8.20875 14.1418 8.9251 14.1418 9.80875V14.6888C14.1418 15.5724 13.4255 16.2888 12.5418 16.2888H10.5728V8.20875ZM11.7728 9.40875V15.0888H12.5418C12.7627 15.0888 12.9418 14.9097 12.9418 14.6888V9.80875C12.9418 9.58784 12.7627 9.40875 12.5418 9.40875H11.7728Z"
        fill={fill}
      />
      <path
        d="M16.4392 8.20875C15.5555 8.20875 14.8392 8.9251 14.8392 9.80875L14.8392 14.6937C14.8392 15.5774 15.5555 16.2937 16.4392 16.2937H16.8081C17.6918 16.2937 18.4081 15.5774 18.4081 14.6937V13.9718H17.2081V14.6937C17.2081 14.9147 17.0291 15.0937 16.8081 15.0937H16.4392C16.2183 15.0937 16.0392 14.9147 16.0392 14.6937L16.0392 9.80875C16.0392 9.58784 16.2183 9.40875 16.4392 9.40875H16.8082C17.0291 9.40875 17.2082 9.58784 17.2082 9.80875V10.5307H18.4082V9.80875C18.4082 8.9251 17.6918 8.20875 16.8082 8.20875H16.4392Z"
        fill={fill}
      />
      <path
        d="M6.9258 16.1638H8.58493L9.87598 8.25611H8.66009L7.75861 13.7777L6.87344 8.25611H5.65812L6.9258 16.1638Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgVdc;
